(function () {
  var ROOT_SELECTOR = '[data-prea-discount-capture]';
  var STORAGE_PREFIX = 'preaDiscountCapture:';
  var DAY_MS = 24 * 60 * 60 * 1000;

  function now() {
    return Date.now();
  }

  function getStorage(name) {
    try {
      return window.localStorage.getItem(STORAGE_PREFIX + name);
    } catch (error) {
      return null;
    }
  }

  function setStorage(name, value) {
    try {
      window.localStorage.setItem(STORAGE_PREFIX + name, String(value));
    } catch (error) {
      return null;
    }
  }

  function getNumber(root, name, fallback) {
    var value = Number(root.dataset[name]);
    return Number.isFinite(value) ? value : fallback;
  }

  function isFutureTimestamp(value) {
    var timestamp = Number(value);
    return Number.isFinite(timestamp) && timestamp > now();
  }

  function isPageReload() {
    try {
      var navEntries = performance.getEntriesByType('navigation');
      if (navEntries && navEntries.length > 0) {
        return navEntries[0].type === 'reload';
      }
      if (window.performance && window.performance.navigation) {
        return window.performance.navigation.type === 1;
      }
    } catch (e) {}
    return false;
  }

  function isSessionDismissed() {
    try {
      if (isPageReload()) {
        window.sessionStorage.removeItem('preaDiscountSessionDismissed');
        return false;
      }
      return window.sessionStorage.getItem('preaDiscountSessionDismissed') === 'true';
    } catch (e) {
      return false;
    }
  }

  function setSessionDismissed() {
    try {
      window.sessionStorage.setItem('preaDiscountSessionDismissed', 'true');
    } catch (e) {}
  }

  function getFocusable(root) {
    return Array.from(root.querySelectorAll([
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(','))).filter(function (element) {
      return element.offsetParent !== null || element === document.activeElement;
    });
  }

  function getResponseMessage(doc, id) {
    var message = doc.getElementById(id);
    return message ? message.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function shouldDelayForAnotherOverlay() {
    return Boolean(
      document.querySelector('quick-add-modal[open], .quick-add-modal[open], cart-drawer.active, cart-drawer.is-open, .hc-customizer:not([hidden])') ||
      document.body.classList.contains('prea-cart-drawer-open') ||
      document.body.classList.contains('hc-customizer-is-open') ||
      document.documentElement.classList.contains('hc-menu-drawer-open')
    );
  }

  function initDiscountCapture(root) {
    if (!root || root.dataset.initialized === 'true') return;

    var dialog = root.querySelector('.prea-discount-capture__dialog');
    var bubble = root.querySelector('[data-prea-discount-bubble]');
    var bubbleOpen = root.querySelector('[data-prea-discount-bubble-open]');
    var bubbleClose = root.querySelector('[data-prea-discount-bubble-close]');
    var form = root.querySelector('[data-prea-discount-form]');
    var input = root.querySelector('input[type="email"]');
    var submitButton = root.querySelector('[data-prea-discount-submit]');
    var submitText = root.querySelector('[data-prea-discount-submit-text]');
    var message = root.querySelector('[data-prea-discount-message]');
    var contentPanel = root.querySelector('[data-prea-discount-content]');
    var successPanel = root.querySelector('[data-prea-discount-success]');
    var copyButton = root.querySelector('[data-prea-discount-copy]');
    var codeTarget = root.querySelector('[data-prea-discount-code]');
    var closeControls = root.querySelectorAll('[data-prea-discount-close]');
    var discountCode = root.dataset.discountCode || 'WELCOME10';
    var previousFocus = null;
    var autoOpened = false;
    var delayTimer = null;
    var inertElements = new Map();
    var scrollPosition = 0;
    var isSubmitting = false;

    if (!dialog || !bubble || !bubbleOpen || !form || !input || !submitButton) return;

    root.dataset.initialized = 'true';
    if (codeTarget) codeTarget.textContent = discountCode;

    function showBubble() {
      if (isFutureTimestamp(getStorage('successUntil'))) return;
      if (isSessionDismissed()) return;
      root.hidden = false;
      bubble.hidden = false;
    }

    function hideBubble() {
      bubble.hidden = true;
    }

    function isModalOpen() {
      return root.classList.contains('is-open');
    }

    function isInsideDialog(target) {
      return target && dialog.contains(target);
    }

    function blockOutsideInteraction(event) {
      if (!isModalOpen() || isInsideDialog(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      dialog.focus({ preventScroll: true });
    }

    function blockOutsideFocus(event) {
      if (!isModalOpen() || isInsideDialog(event.target)) return;
      event.stopImmediatePropagation();
      dialog.focus({ preventScroll: true });
    }

    function setModalEventGuards(enabled) {
      var method = enabled ? 'addEventListener' : 'removeEventListener';
      document[method]('pointerdown', blockOutsideInteraction, true);
      document[method]('click', blockOutsideInteraction, true);
      document[method]('touchstart', blockOutsideInteraction, { capture: true, passive: false });
      document[method]('touchmove', blockOutsideInteraction, { capture: true, passive: false });
      document[method]('wheel', blockOutsideInteraction, { capture: true, passive: false });
      document[method]('focusin', blockOutsideFocus, true);
    }

    function lockPageScroll(enabled) {
      if (!enabled) {
        document.documentElement.classList.remove('prea-discount-capture-open');
        document.body.classList.remove('prea-discount-capture-open');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('left');
        document.body.style.removeProperty('right');
        document.body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);
        return;
      }

      scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('prea-discount-capture-open');
      document.body.classList.add('prea-discount-capture-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollPosition + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function setPageInert(enabled) {
      if (!enabled) {
        inertElements.forEach(function (state, element) {
          if (state.wasInert) {
            element.setAttribute('inert', '');
          } else {
            element.removeAttribute('inert');
          }

          if (state.ariaHidden === null) {
            element.removeAttribute('aria-hidden');
          } else {
            element.setAttribute('aria-hidden', state.ariaHidden);
          }
        });
        inertElements.clear();
        return;
      }

      Array.from(document.body.children).forEach(function (element) {
        if (element === root || element.contains(root) || root.contains(element)) return;
        if (inertElements.has(element)) return;

        inertElements.set(element, {
          wasInert: element.hasAttribute('inert'),
          ariaHidden: element.getAttribute('aria-hidden')
        });
        element.setAttribute('inert', '');
        element.setAttribute('aria-hidden', 'true');
      });
    }

    function openModal(manual) {
      if (shouldDelayForAnotherOverlay()) {
        window.setTimeout(function () {
          openModal(manual);
        }, 1200);
        return;
      }

      previousFocus = document.activeElement;
      root.hidden = false;
      hideBubble();
      root.classList.add('is-open');
      lockPageScroll(true);
      setPageInert(true);
      setModalEventGuards(true);
      dialog.focus({ preventScroll: true });
      if (manual) setStorage('manualOpenAt', now());
    }

    function closeModal(showCollapsed) {
      setModalEventGuards(false);
      root.classList.remove('is-open');
      setPageInert(false);
      lockPageScroll(false);

      if (showCollapsed) {
        showBubble();
        setStorage('dismissedUntil', now() + getNumber(root, 'dismissDays', 7) * DAY_MS);
      } else {
        hideBubble();
        window.setTimeout(function () {
          if (!root.classList.contains('is-open')) root.hidden = true;
        }, 180);
      }

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus({ preventScroll: true });
      }
    }

    function maybeAutoOpen() {
      if (autoOpened) return;
      if (isFutureTimestamp(getStorage('successUntil'))) return;
      if (isSessionDismissed()) {
        hideBubble();
        root.hidden = true;
        return;
      }
      if (isFutureTimestamp(getStorage('dismissedUntil'))) {
        showBubble();
        return;
      }

      autoOpened = true;
      openModal(false);
    }

    function scheduleAutoOpen() {
      if (window.Shopify && Shopify.designMode) {
        showBubble();
        return;
      }

      if (isFutureTimestamp(getStorage('successUntil'))) return;
      if (isSessionDismissed()) {
        hideBubble();
        root.hidden = true;
        return;
      }
      if (isFutureTimestamp(getStorage('dismissedUntil'))) {
        showBubble();
        return;
      }

      var delayMs = getNumber(root, 'delayMs', 9000);
      var scrollDepth = getNumber(root, 'scrollDepth', 35);

      delayTimer = window.setTimeout(maybeAutoOpen, delayMs);

      window.addEventListener('scroll', function onScroll() {
        var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        var depth = Math.round((window.scrollY / scrollable) * 100);
        if (depth < scrollDepth) return;
        window.removeEventListener('scroll', onScroll);
        window.clearTimeout(delayTimer);
        maybeAutoOpen();
      }, { passive: true });
    }

    function setLoading(isLoading) {
      submitButton.disabled = isLoading;
      submitButton.classList.toggle('is-loading', isLoading);
      if (submitText) {
        submitText.textContent = isLoading
          ? submitButton.dataset.loadingText || 'Submitting'
          : submitButton.dataset.defaultText || submitText.textContent;
      }
    }

    function setMessage(text, type) {
      if (!message) return;
      message.textContent = text || '';
      message.hidden = !text;
      message.classList.toggle('is-error', type === 'error');
      message.classList.toggle('is-success', type === 'success');
    }

    function showSuccess() {
      setStorage('successUntil', now() + getNumber(root, 'successDays', 180) * DAY_MS);
      setMessage(root.dataset.successMessage || '', 'success');
      if (contentPanel) contentPanel.hidden = true;
      if (successPanel) successPanel.hidden = false;
    }

    closeControls.forEach(function (control) {
      control.addEventListener('click', function () {
        closeModal(true);
      });
    });

    bubbleOpen.addEventListener('click', function () {
      openModal(true);
    });

    if (bubbleClose) {
      bubbleClose.addEventListener('click', function () {
        setSessionDismissed();
        setStorage('dismissedUntil', now() + getNumber(root, 'dismissDays', 7) * DAY_MS);
        hideBubble();
        window.setTimeout(function () {
          if (!root.classList.contains('is-open')) root.hidden = true;
        }, 180);
      });
    }

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(true);
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = getFocusable(dialog);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    function handleSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (isSubmitting) return;

      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }

      isSubmitting = true;
      setLoading(true);
      setMessage('', '');

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'text/html'
        }
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var successMessage = getResponseMessage(doc, 'PreaDiscountCapture-success');
          var errorMessage = getResponseMessage(doc, 'PreaDiscountCapture-error');

          if (successMessage || !errorMessage) {
            form.reset();
            showSuccess();
            return;
          }

          if (/already|taken|exists/i.test(errorMessage)) {
            showSuccess();
            return;
          }

          setMessage(errorMessage || root.dataset.errorMessage || '', 'error');
        })
        .catch(function () {
          setMessage(root.dataset.requestErrorMessage || '', 'error');
        })
        .finally(function () {
          isSubmitting = false;
          setLoading(false);
        });
    }

    form.addEventListener('submit', handleSubmit, true);

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var onCopied = function () {
          setMessage(root.dataset.copySuccessMessage || '', 'success');
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(discountCode).then(onCopied).catch(onCopied);
        } else {
          onCopied();
        }
      });
    }

    scheduleAutoOpen();
  }

  function init(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initDiscountCapture);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
